import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const UserEditProfile = lazyLoader(
  () =>
    import("Containers/Settings/UserProfile/UserEditProfile/UserEditProfile")
);

export const EditUserProfile = () => {
  return (
    <Layout>
      <UserEditProfile />
    </Layout>
  );
};
